module.exports = __webpack_public_path__ + "media/Directory.f8f1e999972dedea5c1ae94d2ada5cb8.svg";